import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CopiaContratoSelecaoComponent } from '../bf-copia-contrato-cli/copia-contrato-selecao.component';
import { EnderecoConclusaoComponent } from '../bf-endereco-cli/endereco-conclusao.component';
import { EnderecoDadosComponent } from '../bf-endereco-cli/endereco-dados.component';
import { EnderecoSelecaoComponent } from '../bf-endereco-cli/endereco-selecao.component';
import { ExtratoContratoComponent } from '../bf-extrato-cli/extrato-contrato.component';
import { ExtratoSelecaoComponent } from '../bf-extrato-cli/extrato-selecao.component';
import { LiquidacaoContratoConclusaoComponent } from '../bf-liquidacao-cli/liquidacao-contrato-conclusao.component';
import { LiquidacaoContratoComponent } from '../bf-liquidacao-cli/liquidacao-contrato.component';
import { LiquidacaoParcelasConclusaoComponent } from '../bf-liquidacao-cli/liquidacao-parcelas-conclusao.component';
import { LiquidacaoParcelasComponent } from '../bf-liquidacao-cli/liquidacao-parcelas.component';
import { LiquidacaoSelecaoComponent } from '../bf-liquidacao-cli/liquidacao-selecao.component';
import { OutrosServicosComponent } from '../bf-outros-servicos-cli/outros-servicos.component';
import { BfPortalComponent } from '../bf-portal/bf-portal.component';
import { SegundaViaContratoComponent } from '../bf-segundavia-cli/segundavia-contrato.component';
import { SegundaViaModalBoletoComponent } from '../bf-segundavia-cli/segundavia-modal-boleto.component';
import { SegundaViaSelecaoComponent } from '../bf-segundavia-cli/segundavia-selecao.component';
import { SegundaViaCarneConclusaoComponent } from '../bf-segundaviacarne-cli/segundaviacarne-conclusao.component';
import { SegundaViaCarneEnderecoComponent } from '../bf-segundaviacarne-cli/segundaviacarne-endereco.component';
import { SegundaviacarneSelecaoComponent } from '../bf-segundaviacarne-cli/segundaviacarne-selecao.component';
import { CentralAtendimentoComponent } from '../central-atendimento/central-atendimento.component';
import { CancelarProdutoAgregadoComponent } from '../bf-cancelarproduto-cli/cancelar-produto-agregado.component';
import { DebitoAutomaticoComponent } from '../debito-automatico/debito-automatico.component';
import { DebitoAutomaticoContratoComponent } from '../debito-automatico/debito-automatico-contrato.component';
import { ErroComponent } from '../erro/erro.component';
import { ErroPrimeiroacessoComponent } from '../erro-primeiroacesso/erro-primeiroacesso.component';
import { HomeComponent } from '../home/home.component';
import { LoginParceiroComponent } from '../login-parceiro/login-parceiro.component';
import { LoginComponent } from '../login/login.component';
import { PrimeiroAcessoTokenComponent } from '../login/primeiro-acesso-token.component';
import { RedirecionamentoComponent } from '../redirecionamento/redirecionamento.component';
import { AuthguardGuard } from '../services/authguard.guard';
import { SessaoService } from '../services/sessao.service';
import { DebitoAutomaticoContratoModalComponent } from '../debito-automatico/debito-automatico-contrato-modal.component';
import { DebitoAutomaticoContratoConclusaoComponent } from '../debito-automatico/debito-automatico-contrato-conclusao.component';
import { OpenBankingComponent } from '../open-banking/open-banking.component';
import { PrimeiroAcessoComponent } from '../componentes/primeiro-acesso/primeiro-acesso.component';
import { RedefinirSenhaComponent } from '../login/redefinir-senha.component';

const routes: Routes = [
  { path: '', redirectTo: '/login-parceiro', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'login-jeep', component: LoginComponent },
  { path: 'login-ford', component: LoginComponent },
  { path: 'login-parceiro', component: LoginParceiroComponent },
  { path: 'login-parceiro-jeep', component: LoginParceiroComponent },
  { path: 'login-parceiro-ford', component: LoginParceiroComponent },
  { path: 'redefinirSenha', component: RedefinirSenhaComponent},
  { path: 'redefinirSenha-jeep', component: RedefinirSenhaComponent },
  { path: 'redefinirSenha-ford', component: RedefinirSenhaComponent },
  { path: 'primeiro-acesso-token', component: PrimeiroAcessoTokenComponent},
  { path: 'primeiro-acesso', component: PrimeiroAcessoComponent },
  { path: 'erro', component: ErroComponent },
  { path: 'erro-primeiro-acesso', component: ErroPrimeiroacessoComponent },
  { path: 'redirecionamento', component: RedirecionamentoComponent },
  {
    path: 'BF-Portal', component: BfPortalComponent,
    children: [
      {
        path: '',
        children: [
          { path: 'home', canActivate: [AuthguardGuard], component: HomeComponent },
          { path: 'segundavia', canActivate: [AuthguardGuard], component: SegundaViaSelecaoComponent },
          { path: 'segundaviacontrato', canActivate: [AuthguardGuard], component: SegundaViaContratoComponent },
          { path: 'segundaviamodalboleto', canActivate: [AuthguardGuard], component: SegundaViaModalBoletoComponent },
          { path: 'endereco', canActivate: [AuthguardGuard], component: EnderecoSelecaoComponent },
          { path: 'enderecoDados', canActivate: [AuthguardGuard], component: EnderecoDadosComponent },
          { path: 'enderecoConclusao', canActivate: [AuthguardGuard], component: EnderecoConclusaoComponent },
          { path: 'segundaviacarne', canActivate: [AuthguardGuard], component: SegundaviacarneSelecaoComponent },
          { path: 'segundaviacarneEndereco', canActivate: [AuthguardGuard], component: SegundaViaCarneEnderecoComponent },
          { path: 'segundaviacarneConclusao', canActivate: [AuthguardGuard], component: SegundaViaCarneConclusaoComponent },
          { path: 'extrato', canActivate: [AuthguardGuard], component: ExtratoSelecaoComponent },
          { path: 'extratocontrato', canActivate: [AuthguardGuard], component: ExtratoContratoComponent },
          { path: 'outrosServicos', canActivate: [AuthguardGuard], component: OutrosServicosComponent },
          { path: 'liquidacao', canActivate: [AuthguardGuard], component: LiquidacaoSelecaoComponent },
          { path: 'liquidacaoContrato', canActivate: [AuthguardGuard], component: LiquidacaoContratoComponent },
          { path: 'liquidacaoContratoConclusao', canActivate: [AuthguardGuard], component: LiquidacaoContratoConclusaoComponent },
          { path: 'liquidacaoParcelas', canActivate: [AuthguardGuard], component: LiquidacaoParcelasComponent },
          { path: 'liquidacaoParcelasConclusao', canActivate: [AuthguardGuard], component: LiquidacaoParcelasConclusaoComponent },
          { path: 'copiaContrato', canActivate: [AuthguardGuard], component: CopiaContratoSelecaoComponent },
          { path: 'central', canActivate: [AuthguardGuard], component: CentralAtendimentoComponent },
          { path: 'debitoautomatico', canActivate: [AuthguardGuard], component: DebitoAutomaticoComponent },
          { path: 'debitoautomaticocontrato', canActivate: [AuthguardGuard], component: DebitoAutomaticoContratoComponent },
          { path: 'debitoautomaticomodal', canActivate: [AuthguardGuard], component: DebitoAutomaticoContratoModalComponent },
          { path: 'debitoautomaticoconclusao', canActivate: [AuthguardGuard], component: DebitoAutomaticoContratoConclusaoComponent },
          { path: 'openbanking', canActivate: [AuthguardGuard], component: OpenBankingComponent },
          { path: 'cancelarprodutoagregado', canActivate: [AuthguardGuard], component: CancelarProdutoAgregadoComponent },
          { path: '', canActivate: [AuthguardGuard], component: HomeComponent },
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [SessaoService]
})

export class AppRoutingModule { }


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/app-routing/app-routing.module.ts